import { SETTINGS } from '../constants'
import _ from 'lodash'
import {defaultSettingsState} from '../../defaulState'
import { setLanguageSettingsToCaptions } from '../../Utils/utils'

const settingsReducer = (state = defaultSettingsState, action) => {
    let _newState = {}

    switch (action.type) {

        case SETTINGS.INIT_SETTINGS:
            _newState = _.cloneDeep(action.payload)
            break;

        case SETTINGS.UPDATE_SETTINGS:
            _newState = _.cloneDeep(action.payload)
            break;

        case SETTINGS.CHANGE_WIDGET_DIMENSION:
            _newState = _.cloneDeep(state)
            _newState.widgetDimensions = {..._newState.widgetDimensions, ...action.payload} 
            break;

        case SETTINGS.CHANGE_DEVICE_TYPE:
            _newState = _.cloneDeep(state)
            _newState.deviceType = action.payload
            break;

        case SETTINGS.UPDATE_SLIDES:
            _newState = _.cloneDeep(state)
            _newState.slides = action.payload
            break;

        case SETTINGS.PREVIEW_TEMPLATE_SLIDES:
            _newState = _.cloneDeep(state)

            _newState.demoIsShow = true
            _newState.slides = action.payload.slides
            _newState.parallaxImage = action.payload.image
            _newState.hasParallax = action.payload.parallax
            _newState.widgetDimensions.editedWidth = action.payload.dimensions.editedWidth
            _newState.widgetDimensions.editedHeight = action.payload.dimensions.editedHeight
            _newState.widgetDimensions.editedWidthMobile = action.payload.dimensions.editedWidthMobile
            _newState.widgetDimensions.editedHeightMobile = action.payload.dimensions.editedHeightMobile
            break;

        case SETTINGS.ADD_LANGUAGE_TO_CAPTIONS:
            _newState = _.cloneDeep(state)
            const {lang, locale} = action.payload
            _newState = setLanguageSettingsToCaptions(_newState, lang, locale)
            break;

        default:
            _newState = state;
            break;
    }
    return _newState

}


export { settingsReducer }